// Helper function to calculate event status
import { WebinarEventStatus } from "../../../_components/webinar/types";

export function calculateWebinarEventStatus(
    eventStartDate: Date,
    duration: number,
): WebinarEventStatus {
    const now = new Date();
    const eventStart = new Date(eventStartDate);
    const eventEnd = new Date(eventStart.getTime() + (duration + 30) * 60000); // Add 30 min buffer

    if (now < eventStart) {
        return "upcoming";
    } else if (now >= eventStart && now <= eventEnd) {
        return "active";
    } else {
        return "ended";
    }
}
